import { Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { CdsProgressModule } from '@cds/ng-web-components/progress';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [NgClass, CdsProgressModule],
})
export class LoadingComponent implements OnInit {
  @Input() overlay = false;
  @Input() overlayInPopup = false;
  constructor() {}
  ngOnInit(): void {}
}
